import { render } from "./TipsIcon.vue?vue&type=template&id=433a161b&scoped=true"
import script from "./TipsIcon.vue?vue&type=script&lang=js"
export * from "./TipsIcon.vue?vue&type=script&lang=js"

import "./TipsIcon.vue?vue&type=style&index=0&id=433a161b&scoped=true&lang=css"

import exportComponent from "/home/www/.jenkins/workspace/131-front-vue-8081/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-433a161b"]])

export default __exports__